"use client";

import { BSRHorizontalEllipsis } from "./bsr/BSRHorizontalEllipsis";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { HorizontalEllipsis as LegacyHorizontalEllipsis } from "./legacy/HorizontalEllipsis";

export const HorizontalEllipsis = createBSRExperimentIcon(
  LegacyHorizontalEllipsis,
  BSRHorizontalEllipsis
);
